import { css, FlattenSimpleInterpolation } from 'styled-components';

import { cvar } from '@/styles/GlobalStyle';

export type FontWeight = 'regular' | 'medium' | 'bold' | 'extra-bold';

export const fontWeight = (fontWeight: FontWeight): FlattenSimpleInterpolation => css`
  font-weight: ${cvar(`v2-font-weight-${fontWeight}`)};
`;
